module.exports = __webpack_public_path__ + "img/img8.d79b0664.png";